<template>
  <div class="checkups">
    <div v-if="checkups && checkups.length > 0">
      <div v-for="item of checkups" :key="item.RecordNo" class="p-3 border-bottom hover">
        <CheckupLink :checkup="item"></CheckupLink>
      </div>
    </div>
    <div class="alert alert-primary" v-else-if="!loading">
      <p>{{ $t("nocheckups") }}</p>
      <p>{{ $t("youcancheckup") }}</p>
      <p>
        {{ $t("contactOperatorForDetials") }}
        <router-link
          :to="`/clinics/0d174bf2-5ee4-4190-95f0-61e082e75f34/inquiry`"
          class="chat-with-us py-2 pl-1 pointer svg"
        >
          <chat-icon></chat-icon>
          <span class="pl-2">{{ $t("operator") }}</span>
        </router-link>
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import ChatIcon from '@/components/Icons/Chat'
import CheckupLink from '@/components/Checkups/Link'
export default {
  components: {
    ChatIcon,
    CheckupLink
  },
  metaInfo: {
    title: 'My Checkups'
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      checkups: 'checkup/checkups'
    })
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/', text: this.$t('checkups') })
    this.fetch()
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setCheckup: 'checkup/set',
      setNavVisible: 'app/setNavVisible',
      setHead: 'head/set',
      resetHead: 'head/reset'
    }),
    async fetch () {
      this.loading = true
      try {
        const params = {
          limit: 20,
          offset: 0
        }
        const response = await this.axios.get('/device/checkups', { params })
        const checkups = response.data.data
        for (const checkup of checkups) {
          this.setCheckup({
            RecordNo: checkup.record_no,
            deviceType: checkup.device_type,
            userId: checkup.user_id,
            created_at: checkup.created_at,
            sections: checkup.sections
          })
        }
        this.loading = false
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "nocheckups": "თქვენ არ გაქვთ ჩატარებული არც ერთი ექსპრეს სკრინინგი.",
      "youcancheckup": "ექსპრეს სკრინინგი შეგიძლიათ ჩაიტაროთ შემდეგ მისამართზე: თბილისი, ა. წერეთლის 2, დინამო არენას ტერიტორიაზე, ტელეკლინიკის ოფისში.",
      "contactOperatorForDetials": "დეტალებზე დაუკავშირდით ტელეკლინიკის",
      "operator": "ოპერატორს",
      "checkups": "ექსპრეს სკრინინგები"
  },
  "en": {
      "nocheckups": "You do not have any express screening entries.",
      "youcancheckup": "You can schedule for express screening.",
      "contactOperatorForDetials": "For more details please contact Teleclinic's",
      "operator": "Operator",
      "checkups": "Express Screenings"
  }
}
</i18n>
